import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import es from "./locales/es.json";
import en from "./locales/en.json";

const resources = {
  es: { translation: es },
  en: { translation: en },
};

const savedLanguage =
  typeof window !== "undefined"
    ? localStorage.getItem("language")
    : null;
const browserLang =
  typeof navigator !== "undefined"
    ? navigator.language?.slice(0, 2)
    : "en";
const initialLng =
  savedLanguage === "es" || savedLanguage === "en"
    ? savedLanguage
    : browserLang === "es"
      ? "es"
      : "en";

i18n.use(initReactI18next).init({
  resources,
  lng: initialLng,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // React ya escapa por defecto
  },
});

export default i18n;

// Force HMR reload - updated translations
